import { FieldDefinition, FieldBuilder, MenuCategories, MenuSubcategories, MENU_CATEGORY_KEY, MENU_SUBCATEGORY_KEY, MENU_NAME_SUFFIX } from '@zendra/shared';

FieldBuilder.setNamespace('Controlling');

export const PAYMENTTYPE_FIELDS: FieldDefinition[] = [
  FieldBuilder
    .text('name', 'Entity.PaymentType.Name')
    .required()
    .minLength(1)
    .maxLength(40)
    .build(),
  FieldBuilder
    .text('code', 'Entity.PaymentType.Code')
    .required()
    .minLength(1)
    .maxLength(3)
    .build(),
  FieldBuilder
    .checkbox('validate', 'Entity.PaymentType.Validate')
    .build(),
];

export const PAYMENTTYPE_CONFIG = {
  entityName: 'PaymentType',
  localizationKey: 'Controlling::Entity.PaymentType',
  fields: PAYMENTTYPE_FIELDS,
  permission: 'ControllingLiquidations.PaymentTypes',
  showInMenu: true,
  menuCategory: MENU_CATEGORY_KEY + MenuCategories.Controlling + MENU_NAME_SUFFIX,
  menuSubcategory: MENU_SUBCATEGORY_KEY + MenuSubcategories.Liquidations + MENU_NAME_SUFFIX,
};
